<template>
  <v-container fluid class="messages">
    <v-toolbar flat>
      <v-container fluid>
        <v-row>
          <v-col col="12" class="d-flex flex-row-reverse">
            <v-btn fab outlined> 1 </v-btn>
            <v-btn icon class="mr-md-5">
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>

    <v-container class="pa-6 pt-10" fluid>
      <v-card outlined class="message-container">
        <v-card-text class="pa-6 py-10">
          <h1>Messages/Notifications</h1>
          <v-spacer></v-spacer>
        </v-card-text>
        <v-container
          fluid
          v-for="(message, index) in messages"
          :key="index"
          class="d-flex flex-row pa-0 mt-5"
          @click="showMessage(message)"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 0 : 0"
              :class="{ 'on-hover': hover, new: !message.readStatus }"
              class="d-flex flex-row rounded-0 pt-5 px-5"
            >
              <v-btn icon fab outlined class="pt-1">
                <v-icon>mdi-bell-outline</v-icon>
              </v-btn>

              <v-container fluid class="pt-1">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>{{ message.subject }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      message.date
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- <p>{{ message.subject }}</p>
                <p>{{ message.date }}</p> -->
              </v-container>
            </v-card>
          </v-hover>
        </v-container>
      </v-card>
    </v-container>

    <v-navigation-drawer
      floating
      right
      absolute
      temporary
      v-model="drawer"
      class="d-flex flex-column"
    >
      <v-container fluid class="py-10">
        <v-container fluid class="d-flex flex-row">
          <v-container fluid>
            <h1 class="ma-0 mb-5">{{ message.subject }}</h1>
          </v-container>
        </v-container>
        <v-container fluid class="d-flex flex-row">
          <v-container fluid>
            <p class="ma-0">From: {{ message.from }}</p>
            <p class="ma-0">To: {{ message.to }}</p>
          </v-container>
          <v-container fluid class="d-flex flex-row-reverse">
            <p class="ma-0">
              Date: {{ new Date(message.date).toISOString().slice(0, 10) }}
            </p>
          </v-container>
          <h1 class="ma-0 grey--text text--lightend-5"></h1>
        </v-container>
      </v-container>

      <v-divider></v-divider>

      <v-container fluid class="py-10">
        <v-container fluid class="pt-1" v-html="message.content">
        </v-container>
      </v-container>

      <v-container fluid class="py-10 mt-auto">
        <v-container fluid class="pt-1 d-flex flex-row-reverse">
          <v-btn class="mr-md-5">
            <v-icon>mdi-bell-outline</v-icon>
            Delete
          </v-btn>
          <v-btn class="mr-md-5">
            <v-icon>mdi-bell-outline</v-icon>
            Reply
          </v-btn>
        </v-container>
      </v-container>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "Messages",
  route: {
    path: "/Messages/",
    name: "Messages",
  },
  data() {
    return {
      drawer: false,
      message: {
        from: "Alexandre Grenier",
        to: "Sonny Juanes",
        subject: "Test 1",
        content: "Lorem Ipsum",
        date: new Date(),
        readStatus: false,
      },
      messages: [
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 1",
          content:
            "<a href='/games/eUTCvBh1uhFoT0ip6UNh'>Link</a> Nulla nec egestas mi. Mauris lobortis velit elit. Cras scelerisque, neque et facilisis sodales, nunc urna hendrerit mauris, ac auctor nulla metus id purus. Sed eu tellus at tellus eleifend placerat. Praesent semper condimentum fringilla. Curabitur ullamcorper, diam sit amet cursus faucibus, diam neque tincidunt velit, laoreet viverra nisl urna sit amet enim. Sed pellentesque, dui non venenatis laoreet, quam nisl dictum libero, vitae pharetra mauris tortor sed enim. Etiam non tempus orci.",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 2",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 3",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
        {
          from: "Alexandre Grenier",
          to: "Sonny Juanes",
          subject: "Test 4",
          content: "Lorem Ipsum",
          date: new Date(),
          readStatus: "false",
        },
      ],
    };
  },
  methods: {
    showMessage(message) {
      this.message = message;
      this.drawer = !this.drawer;
      console.log(message);
    },
  },
};
</script>

<style lang="sass">
.messages

  .v-navigation-drawer__content
    display: flex
    flex-flow: column nowrap

  .v-navigation-drawer
    position: fixed
    width: 50% !important
  .v-overlay--active
    position: fixed

  .message-container
    max-height: 80vh
    overflow: scroll
  .v-card.on-hover
    background-color: #D8D8D8
    cursor: pointer
    >.v-card__text
      color: #000

  .v-card
    width: 100%
</style>
